module.exports = __webpack_public_path__ + "img/logo_x.9c5fe974.svg";